export enum Plan {
  Free = 'free',
  Pro = 'pro',
  Unlimited = 'unlimited',
}

export const PLAN_HIERARCHY: Record<Plan, number> = {
  [Plan.Free]: 0,
  [Plan.Pro]: 1,
  [Plan.Unlimited]: 2,
};

export type PricingPlan = {
  name: string;
  type: 'pro' | 'unlimited';
  interval: 'monthly' | 'yearly';
  currency: string;
  price: number;
};

export type MeteoFeatures = {
  EcmwfWind: boolean;
  GfsWind: boolean;
  ecmwf: boolean;
  gfs: boolean;
  windComparison: boolean;
  gfsWave: boolean;
  nemo: boolean;
};

export type RoutingFeatures = {
  delayedStart: boolean;
  deterministicRoutingsPerDay: number;
  ensembleRoutingsPerDay: number;
  models: {
    deterministic: boolean;
    ensemble: boolean;
  };
  polarSpread: boolean;
  table: boolean;
  meteogram: boolean;
  csv: boolean;
};

export type PlanFeatures = {
  boats: number;
  liveData: boolean;
  myRoutes: number;
  meteo: MeteoFeatures;
  routing: RoutingFeatures;
};

export type PricingResponse = {
  plans: PricingPlan[];
  features: Record<Plan, PlanFeatures>;
};
